<template>
  <tr class="bg-white">
    <td
      v-for="column in columns"
      :key="'loading_cell_' + column.key"
      class="border-b border-gray-200"
    >
      <div
        class="m-4 animate-pulse h-4 bg-gray-200 rounded-xs"
        :class="randomWidth()"
      ></div>
    </td>
  </tr>
</template>

<script setup>
defineProps({
  columns: {
    type: Array,
    required: true,
  },
});

const randomWidth = () => {
  const widths = ["w-1/4", "w-1/2", "w-1/3", "w-2/3", "w-3/4"];

  return widths[Math.floor(Math.random() * widths.length)];
};
</script>
